import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import React, { useState } from 'react'
import { useEffect } from 'react';
import moment from 'moment'

import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    LabelList,
    ResponsiveContainer
} from "recharts";
import { jsonrepair } from 'jsonrepair';
import ReactSelect from 'react-select';
import BusquedaFechas from '../pedidos/BusquedaFechas';

const ExampleCustomInput = ({ value, onClick, nombre }) => (
    <button className="btn boton_estandar" onClick={onClick}>
        <FontAwesomeIcon icon={faCalendarAlt} size="1x" /> {nombre}: {value}
    </button>
)

const CustomizedLabel = (props) => {
    const { x, y, stroke, value } = props;

    return (
        <text x={x} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor="middle">
            {value}
        </text>
    );
};

const CustomizedAxisTick = (props) => {
    const { x, y, payload } = props;
    return (
        <g transform={`translate(${x},${y})`}>
            <text
                x={0}
                y={0}
                dy={16}
                textAnchor="end"
                fill="#666"
                transform="rotate(-35)"
            >
                {payload.value}
            </text>
        </g>
    );
};

const Estadisticas = ({ baseUrl }) => {
    const [startDate, setStartDate] = useState(new Date());
    const [datosGrafica, setDatosGrafica] = useState([])
    const [tipoGrafica, setTipoGrafica] = useState({ value: "valor", label: "Ventas" })
    const [fechaInicial, setFechaInicial] = useState(new Date())
    const [fechaFinal, setFechaFinal] = useState(new Date())
    const [datosGraficaTop, setDatosGraficaTop] = useState([])

    useEffect(() => {
        traeDatos()
    }, [startDate, tipoGrafica])

    const traeDatos = async () => {
        try {

            let inicioFechaFormat = moment(startDate).format("YYYY-01-01")
            let finalFechaFormat = moment(startDate).format("YYYY-12-") + moment().daysInMonth();

            const resp = await axios.get(baseUrl, { params: { tipo: 'avanzada', date: inicioFechaFormat, date2: finalFechaFormat } })
            let datosItems = [
                {
                    name: "Enero",
                    total: 0,
                    app: 0,
                    tienda: 0,
                    pagina: 0
                },
                {
                    name: "Febrero",
                    total: 0,
                    app: 0,
                    tienda: 0,
                    pagina: 0
                },
                {
                    name: "Marzo",
                    total: 0,
                    app: 0,
                    tienda: 0,
                    pagina: 0
                },
                {
                    name: "Abril",
                    total: 0,
                    app: 0,
                    tienda: 0,
                    pagina: 0
                },
                {
                    name: "Mayo",
                    total: 0,
                    app: 0,
                    tienda: 0,
                    pagina: 0
                },
                {
                    name: "Junio",
                    total: 0,
                    app: 0,
                    tienda: 0,
                    pagina: 0
                },
                {
                    name: "Julio",
                    total: 0,
                    app: 0,
                    tienda: 0,
                    pagina: 0
                },
                {
                    name: "Agosto",
                    total: 0,
                    app: 0,
                    tienda: 0,
                    pagina: 0
                },
                {
                    name: "Septiembre",
                    total: 0,
                    app: 0,
                    tienda: 0,
                    pagina: 0
                },
                {
                    name: "Octubre",
                    total: 0,
                    app: 0,
                    tienda: 0,
                    pagina: 0
                },
                {
                    name: "Noviembre",
                    total: 0,
                    app: 0,
                    tienda: 0,
                    pagina: 0
                },
                {
                    name: "Diciembre",
                    total: 0,
                    app: 0,
                    tienda: 0,
                    pagina: 0
                }
            ]
            if (resp.data.length == 0) return setDatosGrafica(datosItems)

            resp.data.map(item => {
                const fechaRegistro = new Date(item.fecha);
                const fechaMensual = fechaRegistro.getMonth();
                const fechaAnual = fechaRegistro.getFullYear();

                const fechaAnualActual = new Date(finalFechaFormat).getFullYear();
                const datosPago = JSON.parse(jsonrepair(item.datosPago))

                if (fechaAnual === fechaAnualActual && item.estado == "Aprobado") {


                    if (datosPago.canal === 'Tienda') {
                        if (tipoGrafica.value === "valor") {
                            datosItems[fechaMensual]['total'] += parseFloat(item.total)
                        } else {
                            datosItems[fechaMensual]['total'] += 1
                        }

                        if (tipoGrafica.value === "valor") {
                            datosItems[fechaMensual]['pagina'] += parseFloat(item.total)

                        } else {
                            datosItems[fechaMensual]['pagina'] += 1
                        }

                    } else if (datosPago.canal === 'Facturación') {
                        if (tipoGrafica.value === "valor") {
                            datosItems[fechaMensual]['total'] += parseFloat(item.total)
                        } else {
                            datosItems[fechaMensual]['total'] += 1
                        }

                        if (tipoGrafica.value === "valor") {
                            datosItems[fechaMensual]['tienda'] += parseFloat(item.total)
                        } else {
                            datosItems[fechaMensual]['tienda'] += 1
                        }

                    } else if (datosPago.canal === 'App') {
                        if (tipoGrafica.value === "valor") {
                            datosItems[fechaMensual]['total'] += parseFloat(item.total)
                        } else {
                            datosItems[fechaMensual]['total'] += 1
                        }

                        if (tipoGrafica.value === "valor") {
                            datosItems[fechaMensual]['app'] += parseFloat(item.total)
                        } else {
                            datosItems[fechaMensual]['app'] += 1
                        }
                    }
                }
            })

            const datos = datosItems.map(item => ({
                ...item,
                total: +item.total.toFixed(2),
                app: +item.app.toFixed(2),
                tienda: +item.tienda.toFixed(2),
                pagina: +item.pagina.toFixed(2),
            }))
            setDatosGrafica(datos)
        } catch (error) {
            console.log(error)
        }

    }


    useEffect(() => {
        traeDatosProductosTop()
    }, [fechaFinal, fechaInicial])

    const traeDatosProductosTop = async () => {
        try {
            let inicioFechaFormat = moment(fechaInicial).format("YYYY-MM-DD")
            let finalFechaFormat = moment(fechaFinal).format("YYYY-MM-DD");

            let datosItems = []

            const resp = await axios.get(baseUrl, { params: { tipo: 'avanzada', date: inicioFechaFormat, date2: finalFechaFormat } })
            if (resp.data.length == 0) return setDatosGraficaTop(datosItems)
            let productosVentas = {}
            resp.data.map(item => {
                const datosPago = JSON.parse(jsonrepair(item.datosPago))

                if (item.estado == "Aprobado" && datosPago.canal != 'Activacion') {
                    const pedido = JSON.parse(jsonrepair(item.pedido))

                    if (pedido) {
                        pedido.map(pe => {
                            if (pe.tipo == "Producto") {
                                productosVentas[pe.nombre_producto] = productosVentas[pe.nombre_producto] ? productosVentas[pe.nombre_producto] + 1 : 1
                            }
                        })
                    }
                }

            })
            const totalObjets = []
            for (const [key, value] of Object.entries(productosVentas)) {
                totalObjets.push({ name: key, total: value })
            }

            const top10Productos = totalObjets.sort((productoA, productoB) => productoB.total - productoA.total).splice(0, 10)
            setDatosGraficaTop(top10Productos)

        } catch (error) {
            console.log(error)
        }
    }
    return (
        <div>
            <div className="row  justify-content-between align-items-center">
                <div className="col-md-4">
                    <br />
                    <h2>Estadisticas:</h2>
                </div>

            </div>
            <hr />

            <div className="alert alert-primary" role="alert">
                En esta gráfica podrás evidenciar rápidamente las ventas totales de cada mes y las puedes clasificar por año.
            </div>
            <div className='row align-items-center'>
                <div className='col-md-4'>
                    <label>Seleccione el tipo de grafica:</label>
                    <ReactSelect
                        placeholder="Seleccione"
                        options={[{
                            label: "Ventas",
                            value: 'valor'
                        },
                        {
                            label: "Cantidad",
                            value: 'cantidad'
                        }]}
                        value={tipoGrafica}
                        onChange={setTipoGrafica}
                    />
                </div>
                <div className="col-md-3">

                    <DatePicker
                        selected={new Date(startDate)}
                        onChange={date => setStartDate(date)}
                        showYearPicker
                        dateFormat="yyyy"
                        customInput={<ExampleCustomInput nombre='Fecha Simple' />}
                    />

                </div>
            </div>

            <ResponsiveContainer width="100%" height={400}>
                <LineChart
                    width={100}
                    height={500}
                    data={datosGrafica}
                    margin={{
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 10
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" height={60} tick={<CustomizedAxisTick />} />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="total" stroke="#82ca9d" label={<CustomizedLabel />} />

                    <Line type="monotone" dataKey="app" stroke="#d039de" />
                    <Line type="monotone" dataKey="tienda" stroke="#8884d8" />
                    <Line type="monotone" dataKey="pagina" stroke="#1874f0" />

                </LineChart>
            </ResponsiveContainer>

            <hr />
            <div className="alert alert-primary" role="alert">
                En esta gráfica podrás evidenciar rápidamente el top 10 de los productos mas vendidos por las fechas seleccionadas.
            </div>
            <div className='row'>
                <div className='col-md-4'>
                    <BusquedaFechas startDate={fechaInicial} setStartDate={setFechaInicial} finalFecha={fechaFinal} setFinalFecha={setFechaFinal} />
                </div>
            </div>
            <ResponsiveContainer width="100%" height={400}>
                <LineChart
                    width={100}
                    height={500}
                    data={datosGraficaTop}
                    margin={{
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 10
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" height={60} tick={<CustomizedAxisTick />} />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="total" stroke="#d039de" label={<CustomizedLabel />} />
                </LineChart>
            </ResponsiveContainer>

        </div>

    )
}

export default Estadisticas